<div class="mat-dialog-output-details">
    <form [formGroup]="outputInputForm">
        <div mat-dialog-title class="dialog-title">
            <h2>{{headerName}} </h2>
            <button mat-icon-button aria-label="close dialog" mat-dialog-close>
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <mat-dialog-content class="mat-typography">
            <div class="device-details-form">
                <mat-grid-list cols="2" rowHeight="80px">
                    <mat-grid-tile>
                        <div class="w-100">
                            <mat-form-field appearance="outline" class="form-feild" *ngIf="!isAddButton">
                                <mat-label>Unique ID </mat-label>
                                <input matInput placeholder="Placeholder" formControlName="uniqueId" readonly />
                                <mat-error *ngIf="outputInputForm.invalid">
                                    {{errorMessageFormField.uniqueID}}
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field appearance="outline" class="form-feild" *ngIf="isAddButton">
                                <mat-label>Potential ID </mat-label>
                                <input matInput placeholder="Placeholder" formControlName="potentialId" readonly />
                                <mat-error *ngIf="outputInputForm.invalid">
                                    {{errorMessageFormField.potentialId}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="w-100">
                            <mat-form-field appearance="outline" class="form-feild">
                                <mat-label>Device Type </mat-label>
                                <mat-select formControlName="deviceType"
                                    (ngModelChange)="handleSelectDeviceType($event)">
                                    <mat-option *ngFor="let deviceTyp of deviceTypsData;"
                                        value="{{deviceTyp.value}}">{{deviceTyp.name}}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="outputInputForm.invalid">
                                    {{errorMessageFormField.deviceType}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="w-100">
                            <mat-form-field appearance="outline" class="form-feild">
                                <mat-label>Type </mat-label>
                                <mat-select formControlName="type" (ngModelChange)="handleSelectType($event)">
                                    <mat-option *ngFor="let typData of typesData;"
                                        value="{{typData.value}}">{{typData.name}}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="outputInputForm.invalid">
                                    {{errorMessageFormField.type}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="w-100">
                            <mat-form-field appearance="outline" class="form-feild">
                                <mat-label>Display Name </mat-label>
                                <input matInput placeholder="Placeholder" formControlName="displayName" />
                                <mat-error *ngIf="outputInputForm.invalid">
                                    {{errorMessageFormField.displayName}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </mat-grid-tile>
                    <!-- <mat-grid-tile>
                        <div class="w-100">
                            <mat-form-field appearance="outline" class="form-feild">
                                <mat-label class="asterix--before">Comport No </mat-label>
                                <mat-select formControlName="comportNumber"
                                    (ngModelChange)="handleSelectComportNumber($event)" [disabled]="!isAddButton">
                                    <mat-option *ngFor="let comprtno of comportNoData;"
                                        value="{{comprtno.value}}">{{comprtno.name}}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="outputInputForm.invalid">
                                    {{errorMessageFormField.comportNo}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </mat-grid-tile> -->
                    <!-- <mat-grid-tile>
                        <div class="w-100">
                            <mat-form-field appearance="outline" class="form-feild">
                                <mat-label>Address </mat-label>
                                <input matInput placeholder="Placeholder" formControlName="address" />
                            </mat-form-field>
                        </div>
                    </mat-grid-tile> -->
                    <mat-grid-tile>
                        <div class="w-100">
                            <mat-form-field appearance="outline" class="form-feild">
                                <mat-label>IP Address</mat-label>
                                <input matInput placeholder="Placeholder" formControlName="ip" />
                                <mat-error *ngIf="outputInputForm.invalid">
                                    {{errorMessageFormField.ipAddress}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="w-100">
                            <mat-form-field appearance="outline" class="form-feild">
                                <mat-label>Port Number </mat-label>
                                <input matInput placeholder="Placeholder" formControlName="portNumber" type="number" />
                                <mat-error *ngIf="outputInputForm.invalid">
                                    {{errorMessageFormField.portNumber}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="w-100">
                            <mat-form-field appearance="outline" class="form-feild">
                                <mat-label>User Name </mat-label>
                                <input matInput placeholder="Placeholder" formControlName="username" />
                                <mat-error *ngIf="outputInputForm.invalid">
                                    {{errorMessageFormField.username}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="w-100">
                            <mat-form-field appearance="outline" class="form-feild">
                                <mat-label>Password </mat-label>
                                <input matInput placeholder="Placeholder" formControlName="password"
                                    [type]="hidePassword ? 'password' : 'text'" />
                                <mat-icon matSuffix (click)="hidePassword = !hidePassword">{{hidePassword ?
                                    'visibility_off' : 'visibility'}}</mat-icon>
                                <mat-error *ngIf="outputInputForm.invalid">
                                    {{errorMessageFormField.password}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="w-100">
                            <mat-form-field appearance="outline" class="form-feild">
                                <mat-label>MAC Address </mat-label>
                                <input matInput placeholder="Placeholder" formControlName="macAddress" />
                                <mat-error *ngIf="outputInputForm.invalid">
                                    {{errorMessageFormField.macAddress}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </mat-grid-tile>
                </mat-grid-list>
                <!-- <div class="nots-text">
                    <span>Note: Changes in parameter value needs server restart.</span>
                </div> -->
            </div>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button mat-stroked-button type="submit" *ngIf="isAddButton" class="add-btn"
                (click)="addOutputs()">Add</button>
            <button mat-stroked-button type="submit" *ngIf="!isAddButton" class="update-btn"
                (click)="updateOutputs()">Update</button>
            <button mat-stroked-button [mat-dialog-close]="true">Close</button>
        </mat-dialog-actions>
    </form>
</div>